import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, DELETE, PUT } from "../../../../services/index";
import { message } from "antd";

export const UseFetchCaseSetting = (companyId) => {
  return useQuery(
    ["getFetchCaseSetting"],
    async () => {
      try {
        const endpoint = `/api/v1/caseSetting/listCaseSetting/${companyId}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Input..");
      }
    }
  );
};

export const UseFetchSubCaseSetting = () => {
  return useQuery(
    ["getFetchSubCaseSetting"],
    async (caseId) => {
      try {
        const endpoint = `/api/v1/caseSetting/listSubCaseSetting/${caseId}`;
        const { result } = await GET(endpoint);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Load Input..");
      }
    }
  );
};

export const UseCreateCaseSetting = () => {
  return useMutation(
    ["createCaseSetting"],
    async (value) => {
      try {
        const endpoint = `/api/v1/caseSetting`;
        const { result } = await POST(endpoint, value);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Create Case Setting..");
      }
    }
  );
};

export const UseCreateSubCaseSetting = () => {
  return useMutation(
    ["createSubCaseSetting"],
    async (value) => {
      try {
        const endpoint = `/api/v1/caseSetting/subcase`;
        const { result } = await POST(endpoint, value);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Create Sub Case Setting..");
      }
    }
  );
};

export const UseUpdateSubCaseSetting = () => {
  return useMutation(
    ["updateSubCaseSetting"],
    async (value) => {
      try {
        const endpoint = `/api/v1/caseSetting/subcase`;
        const { result } = await PUT(endpoint, value);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Update Sub Case Setting..");
      }
    }
  );
};

export const UseUpdateCaseSetting = () => {
  return useMutation(
    ["updateCaseSetting"],
    async (value) => {
      try {
        const endpoint = `/api/v1/caseSetting`;
        const { result } = await PUT(endpoint, value);
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Update Case Setting..");
      }
    }
  );
};

export const UseToggleCaseEnable = () => {
  return useMutation(
    ["toggleCaseEnable"],
    async ({ id, target, enable }) => {
      const endpoint = `/api/v1/caseSetting/enable`;
      return await PUT(endpoint, { id, target, enable });
    }
  );
};

export const UseDeleteCaseSetting = () => {
  return useMutation(
    ["deleteCaseSetting"],
    async (value) => {
      try {
        const endpoint = `/api/v1/caseSetting/${value}`;
        const { result } = await DELETE(endpoint);
        message.success("Case Deleted Successfully..");
        return result;
      } catch (error) {
        await message.destroy();
        message.error("Failed To Delete Case Setting..");
      } finally {
        await message.destroy();
      }
    }
  );
};
